export default "__VITE_ASSET__D3Anp4fD__"